import React from "react";

/**
 * Phase 1 — StatusChip
 *
 * Single chip component for every shelf/queue/state indicator.
 * Replaces the 5 ad-hoc badge treatments in the legacy codebase.
 *
 *   <StatusChip tone="expired">Expired</StatusChip>
 *   <StatusChip tone="urgent">Urgent ≤3d</StatusChip>
 *   <StatusChip tone="soon">Soon 4–7d</StatusChip>
 *   <StatusChip tone="fresh">Fresh</StatusChip>
 *   <StatusChip tone="neutral">Pending</StatusChip>
 *
 * Permanent rule: tone is the ONLY allowed visual variation. No new
 * chip styles. New states map to one of the tones below.
 */
const TONE_CLASSES = {
  expired: "bg-status-expired-bg text-status-expired",
  urgent:  "bg-status-urgent-bg  text-status-urgent",
  soon:    "bg-status-soon-bg    text-status-soon",
  fresh:   "bg-status-fresh-bg   text-status-fresh",
  neutral: "bg-status-neutral-bg text-status-neutral",
};

export default function StatusChip({
  children,
  tone = "neutral",
  className = "",
  "data-testid": testId,
  ...rest
}) {
  const toneClass = TONE_CLASSES[tone] || TONE_CLASSES.neutral;
  return (
    <span
      className={`inline-flex items-center h-6 px-2.5 rounded-chip font-mono text-[11px] font-bold uppercase tracking-wider whitespace-nowrap ${toneClass} ${className}`}
      data-testid={testId}
      {...rest}
    >
      {children}
    </span>
  );
}
